export default "__VITE_ASSET__C30iy91c__"